import { createContext } from 'react'
import type { ReactNode } from 'react'

export interface PropertyRateActionProps {
  rate: App.EnrichedPropertyRate
  property: App.Property.Property
  duration: number
  checkIn: string | undefined
  checkOut: string | undefined
  rooms: Array<App.Occupants>
  disabled: boolean
}

export type PropertyRateActionRenderer = (props: PropertyRateActionProps) => ReactNode

const PropertyRateActionContext = createContext<PropertyRateActionRenderer | undefined>(undefined)

export default PropertyRateActionContext
